import { yupResolver } from "@hookform/resolvers/yup";
import { Modal } from "flowbite-react";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import allImgPaths from "../../assets";
import Layout, { Breadcrumb, Container } from "../../components/layout";
import { useAppState } from "../../context";
import { profileValidation } from "../../validations";

import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { Button, OtpInput, SendOtpForm, TextBox } from "../../components";
import { setGetLsEncryptDecryptData } from "../../shared/functions";

const Profile = () => {
  const {
    sendOtpWithMobile,
    isSendOtpMobile,
    isVerifiedMobileOtp,
    otpDataFromMobile,
    userData,
    verifyNewMobile,
    wrongMobileOtp,
    clearOtpDataFromMobile,
    updateStateUserData,
    updateState,
    profileData,
    getProfile,
    updateProfile,
    setProfileImageData,
    //getSignUrlForImage,
  } = useAppState("auth");
  //organization_id
  //const { setProfileImageData, updateUserProfileData } = useAppState("profile");
  const [openModal, setOpenModal] = useState(false);
  const [changeMobile, setChangeMobile] = useState(false);
  const [lastProfilePic] = useState<any | null>(null);
  const [preview, setPreview] = useState<any | null>(null);
  //const [, setProfileImgFile] = useState<File | undefined>();
  const [instImgPreview, setInstImgPreview] = useState<any | null>(null);
  const [inputMobile, setInputMobile] = useState(0);
  const [isOtpSendMobile, setIsOtpSendMobile] = useState(isSendOtpMobile);

  const navigate = useNavigate();

  const {
    handleSubmit,
    setValue,
    formState: { errors },
    control,
  } = useForm({
    defaultValues: {
      dp: "",
      name: userData ? userData?.name : "",
      phone: userData ? userData?.mobileNo : "",
    },
    mode: "all",
    reValidateMode: "onChange",
    resolver: yupResolver(profileValidation),
  });

  useEffect(() => {
    setIsOtpSendMobile(isSendOtpMobile);
  }, [isSendOtpMobile]);

  useEffect(() => {
    if (!instImgPreview) {
      const instImageSrc = `${process.env.REACT_APP_API_URL}/user.png`;
      setInstImgPreview(instImageSrc);
    }
  }, [instImgPreview]);

  useEffect(() => {
    const callGetProfile = async () => {
      const profile = await getProfile();
      // Update state with the fetched profile data
      updateState({ profileData: profile });
    };
    callGetProfile();
  }, []);

  useEffect(() => {
    setValue("name", profileData?.name ? profileData?.name : userData?.name);
    setValue("phone", profileData ? profileData?.mobileNo : "");

    let dpURL =
      `${process.env.REACT_APP_API_URL}/api/users/profileImage/` +
      (profileData && profileData?.profileUrl
        ? profileData?.profileUrl
        : userData.profileUrl);

    if (userData.profileUrl === null || userData.profileUrl === undefined) {
      dpURL = `${process.env.REACT_APP_API_URL}/user.png`;
    }

    setValue("dp", dpURL);
    setPreview(dpURL);
  }, [profileData]);

  //console.log("preview", preview);

  const onSubmit = async (data: any) => {
    const profileRes = await updateProfile(data?.name);
    //console.log("profileRes", profileRes);

    if (profileRes) {
      updateState({ userData: { ...userData, name: data?.name } });

      // Optionally, store the updated user data in local storage
      setGetLsEncryptDecryptData(
        "set",
        "userData",
        JSON.stringify({ ...userData, name: data?.name }),
      );
      const callDelayInt = setTimeout(() => {
        clearTimeout(callDelayInt);
        navigate("/dashboard");
      }, 200);
    }
  };

  // const changeMobileHandler = () => {
  //   setChangeMobile(true);
  //   setOpenModal(true);
  // };
  //console.log("isOtpSendMobile => ", isOtpSendMobile);

  const sendOtpWithMobileHandler: any = async (mobileNum: string) => {
    setInputMobile(parseFloat(mobileNum));
    await sendOtpWithMobile(parseFloat(mobileNum), userData.id, "profile");
  };

  const resendOtpHandler = () => {
    sendOtpWithMobileHandler(String(inputMobile));
    //clearOtpDataFromMobile();
  };

  useEffect(() => {
    if (isVerifiedMobileOtp) {
      setValue("phone", String(inputMobile));
      clearOtpDataFromMobile();
      setOpenModal(false);
      setIsOtpSendMobile(false);
    }
  }, [isVerifiedMobileOtp]);

  const verifyNewMobileFun = async (val: string) => {
    const res = await verifyNewMobile(inputMobile, parseFloat(val));

    if (res) {
      setOpenModal(false);
      updateState({ otpDataFromMobile: {} });
      setChangeMobile(false);
      setIsOtpSendMobile(false);
    }
  };

  const verifyOtpHandler = (val: string) => {
    verifyNewMobileFun(val);
  };

  const closeModalHandler = () => {
    setOpenModal(false);
    setIsOtpSendMobile(false);
    clearOtpDataFromMobile();
  };

  const deleteProfileImage = async () => {
    const profileFormData = new FormData();
    profileFormData.append("profileUrl", "null");
    setPreview("");
    //return;
    const profileRes = await setProfileImageData(profileFormData);
    //return;

    if (profileRes.status) {
      setPreview("");
      setValue("dp", "");
      const userData: any =
        localStorage.getItem("userData") !== "undefined"
          ? setGetLsEncryptDecryptData("get", "userData") === "false"
            ? {}
            : setGetLsEncryptDecryptData("get", "userData")
          : {};
      userData.dp = null;
      userData.profileUrl = null;

      //localStorage.setItem("userData", JSON.stringify(userData));
      setGetLsEncryptDecryptData("set", "userData", JSON.stringify(userData));
      updateStateUserData();
      setPreview(null);
    }
  };

  const uploadProfileLogo = async (_profileImgFile: any) => {
    const profileFormData = new FormData();
    const profileFile: any = _profileImgFile;

    if (profileFile) {
      profileFormData.append("profileUrl", profileFile);
      const profileImgRes = await setProfileImageData(profileFormData);

      if (profileImgRes.status) {
        const profileImage = `${process.env.REACT_APP_API_URL}/api/users/profileImage/${profileImgRes?.data?.profileUrl}`;

        setPreview(profileImage);
        //setLastProfilePic(profileImage);
        setValue("dp", profileImage);

        const userData: any =
          localStorage.getItem("userData") !== "undefined"
            ? setGetLsEncryptDecryptData("get", "userData") === "false"
              ? {}
              : setGetLsEncryptDecryptData("get", "userData")
            : {};
        userData.dp = profileImage;
        userData.profileUrl = profileImgRes?.data?.profileUrl;
        //userData.profileDetail.user.dp = profileImage;
        setGetLsEncryptDecryptData("set", "userData", JSON.stringify(userData));
        updateStateUserData();
      } else {
        //console.log('getValues("dp")', getValues("dp"));
        setPreview(lastProfilePic);
      }
    } else {
      setPreview(lastProfilePic);
      toast.error("Please upload new profile image.");
    }
  };

  const selectProfileImage = async () => {
    const target = document.getElementById(
      "profileImage",
    ) as HTMLInputElement & {
      files: FileList;
    };

    //console.log("target >> ", target);

    const _size = target.files[0].size;
    //console.log("_size", _size);

    if (_size > 1000000) {
      toast.error("Profile image size should not be greater than 1 MB");
    } else {
      const file = new FileReader();
      file.onload = async function () {
        //setPreview(file.result);
        setValue("dp", String(file.result));
        setPreview(file.result);
        await uploadProfileLogo(target.files[0]);
        target.value = "";
      };
      try {
        file.readAsDataURL(target.files[0]);
      } catch (error) {
        console.log(error);
      }
    }
  };

  const userRoleId = userData.currentAccount?.userRole?._id;
  const roleConfigIds = (
    userData.roleConfigs?.configObj || userData.roleConfigs
  )?.map((config: any) => config.roleName === "developer" && config.roleId);

  const shouldDisplayStateCard = roleConfigIds.includes(userRoleId);

  return (
    <Layout>
      <Modal show={openModal} onClose={() => closeModalHandler()} size="xl">
        <Modal.Header className="[&_.ml-auto]:!hidden [&>h3]:!text-[16px] [&>h3]:!font-semibold">
          {changeMobile && "Update Mobile Number"}
        </Modal.Header>
        <Modal.Body>
          <div className="space-y-6">
            {changeMobile && (
              <>
                <SendOtpForm
                  forUsername={false}
                  // userId={userData.id}
                  info
                  type="number"
                  min={10}
                  max={10}
                  label="New Mobile Number *"
                  isDisabled={isOtpSendMobile}
                  title="Please update your mobile number"
                  onSendOtp={sendOtpWithMobileHandler}
                />
                <OtpInput
                  value={otpDataFromMobile.generatedOtp}
                  forUsername={false}
                  label="New Mobile Number *"
                  isOtpDisabled={!isOtpSendMobile}
                  isDisabled={!isOtpSendMobile}
                  otpSendSuccess={isOtpSendMobile}
                  onSubmit={verifyOtpHandler}
                  closeModal={closeModalHandler}
                  wrongOtp={wrongMobileOtp}
                  onSendOtp={resendOtpHandler}
                />
              </>
            )}
          </div>
        </Modal.Body>
      </Modal>

      <Breadcrumb title="My Profile" />
      <Container>
        <div className="">
          <div className="container mx-auto">
            <div className="gri">
              <div className="rounded-full">
                <div className="flex">
                  <label
                    htmlFor="profileImage"
                    className="relative cursor-pointer"
                  >
                    <div className="pt-3 rounded-full flex justify-center items-center">
                      <input
                        id="profileImage"
                        className="hidden"
                        type="file"
                        name="dp"
                        accept=".jpg,.jpeg,.png"
                        onChange={selectProfileImage}
                      />
                      {/* <img
                        src={allImgPaths.profileIcon}
                        id="profileImage"
                        alt="profileImage"
                      /> */}

                      <div className="flex align-middle group gap-4 relative cursor-pointer rounded-full w-20">
                        {preview ? (
                          <div className="contents">
                            <img
                              src={preview}
                              className={`w-20 h-20 rounded-full relative`}
                              alt=""
                            />
                            {/* <div className="absolute bottom-0 left-[54px] bg-[#1B1C1E] p-[6px] rounded-full cursor-pointer hidden group-hover:block">
                              <img
                                src={allImgPaths.camera}
                                className={`w-3 h-3`}
                                alt="Camera Icon"
                              />
                            </div> */}
                            <div
                              className="absolute right-0 rounded-full cursor-pointer hidden group-hover:block"
                              onClick={(e) => {
                                e.preventDefault();
                                deleteProfileImage();
                              }}
                            >
                              <img
                                src={allImgPaths.deleteRoundedIcon}
                                className={`w-6 h-6`}
                                alt="Delete Icon"
                              />
                            </div>
                          </div>
                        ) : (
                          <div>
                            <img
                              src={allImgPaths.profileIcon}
                              className="relative z-0"
                              id="profileImage"
                              alt="profileImage"
                            />
                            <div className="absolute bottom-0 left-[54px] bg-[#1B1C1E] p-[6px] rounded-full cursor-pointer hidden group-hover:block">
                              <img
                                src={allImgPaths.camera}
                                className={`w-3 h-3`}
                                alt="Camera Icon"
                              />
                            </div>
                          </div>
                        )}
                      </div>

                      {/* <div className="flex align-middle gap-4">
                          <label
                            htmlFor="profileImage"
                            className="relative cursor-pointer top-4 right-5"
                          >
                            <div className="h-7 w-7 bg-[#1B1C1E] flex items-center justify-center rounded-full">
                              <img
                                src={allImgPaths.camera}
                                className={`h-5 w-5`}
                                alt="Camera Icon"
                              />
                            </div>
                          </label>
                        </div> */}
                    </div>
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div className="my-5">
            <hr />
          </div>
          <div className="container mx-auto">
            <form onSubmit={handleSubmit(onSubmit)}>
              <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 lg:gap-4">
                <div>
                  <label htmlFor="" className="font-medium">
                    Enter Name <span className="text-[red]">*</span>
                  </label>
                  <TextBox
                    label="Enter Name"
                    name="name"
                    control={control}
                    errors={errors}
                    min={50}
                    max={50}
                  />
                </div>
                <div className="col-span-2">
                  {shouldDisplayStateCard ? (
                    <>
                      <div className="grid grid-cols-2 gap-2 lg:border-l-2 lg:border-gray-300 pl-[15px]">
                        {[
                          { label: "Name", value: userData?.name },
                          { label: "Phone Number", value: userData?.mobileNo },
                          {
                            label: "Firm Name",
                            value:
                              userData?.currentAccount?.developer[0]
                                ?.companyName,
                          },
                          {
                            label: "Office Address",
                            value:
                              userData?.currentAccount?.developer[0]
                                ?.officeAddress,
                          },
                          {
                            label: "Contact Person Name",
                            value:
                              userData?.currentAccount?.developer[0]?.user
                                ?.name,
                          },
                          {
                            label: "Promoter Name",
                            value:
                              userData?.currentAccount?.developer[0]
                                ?.promoterName,
                          },
                          {
                            label: "Email",
                            value:
                              userData?.currentAccount?.developer[0]?.user
                                ?.email,
                          },
                          {
                            label: "Website",
                            value:
                              userData?.currentAccount?.developer[0]?.website,
                          },
                        ].map((detail, index) => (
                          <div key={index}>
                            <h3 className="text-[15px]">
                              <span className="font-bold mr-2">
                                {detail.label}:
                              </span>
                              {detail.value}
                            </h3>
                          </div>
                        ))}
                      </div>
                    </>
                  ) : (
                    ""
                  )}
                </div>
              </div>

              <div className="flex items-center justify-end mt-16 gap-7">
                <div>
                  <Button
                    variant="outlined"
                    className="!h-10 !text-sm !px-4"
                    onClick={() => {
                      navigate("/dashboard");
                    }}
                  >
                    Cancel
                  </Button>
                </div>
                <div>
                  <Button
                    variant="contained"
                    className="!h-10 !text-sm !px-4"
                    type="submit"
                  >
                    Save
                  </Button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </Container>
    </Layout>
  );
};

export default Profile;
